var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowClose = function SvgArrowClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.9 20.6V3h1.5v17.6zm-9-15.7 7.2 7.2-7.2 7.2-1.1-1.1 5.4-5.4H1.6v-1.5h14.6l-5.4-5.4 1.1-1.1Z"
  })));
};
export { SvgArrowClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0yMC45IDIwLjZWM2gxLjV2MTcuNmgtMS41Wm0tOS0xNS43IDcuMiA3LjItNy4yIDcuMi0xLjEtMS4xIDUuNC01LjRIMS42di0xLjVoMTQuNmwtNS40LTUuNCAxLjEtMS4xWiIvPjwvc3ZnPg==";